import React, { useCallback, useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useIntl } from 'react-intl';
import {
    Modal,
    Button
} from '@gpstrackit/gtc-react-controls';

import {
    Alert,
    Typography
} from '@mui/material';

import { NotificationManager } from 'Components/Notifications';

//actions
import {
    reset,
    closeDeleteModal,
    deleteDynamicForms
} from './redux/slice';

import './styles.scss';

const DeleteForms = (props) => {
    const { messages } = useIntl();
    const dispatch = useDispatch();

    const { refresh } = props;

    const open = useSelector(state => state.dynamicFormsDeleteRedux.open);
    const response = useSelector(state => state.dynamicFormsDeleteRedux.response);
    const loading = useSelector(state => state.dynamicFormsDeleteRedux.loading);
    const dynamicForms = useSelector(state => state.dynamicFormsDeleteRedux.dynamicForms);
    const error = useSelector(state => state.dynamicFormsDeleteRedux.error);

    const [errorMessage, setErrorMessage] = useState("");

    useEffect(() => {
        if (open && response && !response?.error) {
            NotificationManager.success(
                messages['dynamicFormsDelete_successMessage'],
                messages['dynamicFormsDelete_success'],
                3000,
                null,
                null,
                'success',
                null
            );

            if (refresh) refresh();
            handleClose();
        }
    }, [open, response]);

    useEffect(() => {
        if (open && error) {
            let errorMessage = response?.error
            if(errorMessage.includes("work orders")){
                errorMessage = messages['dynamicFormsDelete_errorByWorkOrders'];
            }
            setErrorMessage(errorMessage || messages['errorMessage']);
            dispatch(reset({ error: false, response: null }));
        }
    }, [error, open, response]);

    const handleClose = useCallback(() => {
        setErrorMessage("");
        dispatch(closeDeleteModal());
        dispatch(reset());
    });

    return (
        <Modal
            title={messages['dynamicFormsDelete_title']}
            open={open}
            loading={loading}
            position="right"
            size="medium"
            handleClose={handleClose}
            footer={(
                <div style={{ display: 'flex', alignItems: "center", justifyContent: 'end', width: '100%' }}>
                    <Button
                        disabled={loading}
                        style={{ marginRight: 8 }}
                        onClick={handleClose}
                        variant='secondary'
                    >
                        {messages['cancel']}
                    </Button>

                    <Button
                        disabled={loading || !dynamicForms?.length}
                        onClick={(e) => {
                            if (e) e.preventDefault();
                            setErrorMessage("");
                            if (dynamicForms?.length) {
                                dispatch(deleteDynamicForms({
                                    ids: dynamicForms?.map(df => df?.id)
                                }));
                            }
                        }}
                        variant='warning'
                    >
                        {messages['delete']}
                    </Button>
                </div>
            )}
        >
            <div className='delete-forms-container'>
                <Typography
                    variant="subtitle2"
                    color="textSecondary"
                >
                    {messages['dynamicFormsDelete_deleteWarning']}
                </Typography>

                {
                    dynamicForms?.length > 0 &&
                    <ul className='delete-tags-list'>
                        {
                            dynamicForms.map((dynamicForm, key) => {
                                return (
                                    <li 
                                        key={key}
                                        style={{
                                            overflow: "hidden",
                                            textOverflow: "ellipsis",
                                            listStylePosition: "inside",
                                            whiteSpace: "nowrap"
                                        }}          
                                    >
                                        <span>
                                            {dynamicForm?.name}
                                        </span>
                                    </li>
                                )
                            })
                        }
                    </ul>
                }

                {errorMessage &&
                    <Alert severity="error" onClose={() => setErrorMessage("")}>{errorMessage}</Alert>
                }

            </div>
        </Modal>
    );
}

export default DeleteForms;